<template>
  <BaseModal
    :heading="$t('website_service.reactivate_modal.title')"
    useForm
    small
    @submit="submit"
    @close="emit('close')"
  >
    <Flex
      direction="column"
      :gap="1.5"
    >
      <BaseAlert
        color="info"
        :text="$t('website_service.reactivate_modal.info')"
      />
      <SubscriptionSummary />
      <BaseCheckbox
        :label="$t('website_service.onboarding.terms.confirmation', { price, ...brandName() })"
        v-model="acceptedTerms"
        required
        v-test="'website-terms-checkbox'"
      />
    </Flex>

    <template #footer>
      <BaseButton
        color="inverted"
        @click="emit('close')"
        v-test="'website-service-reactivate-website-close'"
      >
        {{ $t('global.actions.close') }}
      </BaseButton>
      <BaseButton
        submitForm
        :loading="loading"
        v-test="'website-service-reactivate-website-submit'"
      >
        {{ $t('global.actions.submit') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { inject, type Ref, ref } from 'vue';
import { brandName } from '@/helpers/brand-name';
import type { Website } from '@/types';
import { REQUEST_WEBSITE_REACTIVATION } from '../../graphql';
import SubscriptionSummary from '../SubscriptionSummary.vue';

const { mutate, loading } = useMutation(REQUEST_WEBSITE_REACTIVATION, {
  variables: {
    input: {},
  },
});

const website = inject<Ref<Website>>('website');
const price = inject<Ref<string>>('price');
const emit = defineEmits(['close']);

const acceptedTerms = ref(false);

const submit = () => {
  if (!acceptedTerms.value) {
    return;
  }

  mutate().then(({ data }) => {
    const responseWebsite = data?.requestWebsiteReactivation?.website;
    website.value = {
      ...website.value,
      reactivationRequestedAt: responseWebsite?.reactivationRequestedAt,
    };
    emit('close');
  });
};
</script>
